export enum AcceptTypes {
  SPREADSHEET = '.xlsx, .xls, .csv, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
